import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { ListagemComponent } from './listagem/listagem.component';
import { RenunciaLimiteAdicionalRoutingModule } from './renuncia-limite-adicional-routing.module';
import { SolicitacaoComponent } from './solicitacao/solicitacao.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RenunciaLimiteAdicionalRoutingModule,
    NgSelectModule
  ],
  declarations: [
    PesquisaComponent,
    ListagemComponent,
    SolicitacaoComponent
  ],
})
export class RenunciaLimiteAdicionalModule {}